// SALA D'ATTESA (GDD §8.5, "Queue Status")
//
// La partita non comincia finche' la stanza non ha abbastanza giocatori. Senza
// questo pannello il giocatore vedrebbe un'arena immobile e penserebbe che il
// gioco si e' bloccato: qui gli si dice che sta aspettando, e quanti manca.
//
// Oggi la soglia sul server e' 1, quindi questo pannello di fatto non compare.
// Serve per quando i bot spariranno (beta e rilascio): entrare da soli in
// un'arena deserta — e per giunta pagando — e' il modo piu' rapido per perdere
// un giocatore.

import React, { useEffect, useState } from 'react';

const WaitingForOperatives = () => {
  const [attesa, setAttesa] = useState(null);

  useEffect(() => {
    const aggiorna = (e) => {
      const d = e.detail || {};
      setAttesa(d.status === 'waiting' ? d : null);
    };
    window.addEventListener('vexel_room_status', aggiorna);
    return () => window.removeEventListener('vexel_room_status', aggiorna);
  }, []);

  if (!attesa) return null;

  return (
    <div className="fomo-overlay" style={{ display: 'flex', zIndex: 9000 }}>
      <div className="fomo-modal">
        <h2 className="glitch-text" data-text="WAITING FOR OPERATIVES">WAITING FOR OPERATIVES</h2>
        <p>
          <span className="neon-amount">{attesa.humans}/{attesa.required}</span> operativi in arena.
        </p>
        <p className="fomo-status" style={{ color: '#aaa' }}>
          La partita comincia appena la stanza è pronta. Nessuno si muove finché non si parte.
        </p>
      </div>
    </div>
  );
};

export default WaitingForOperatives;
